import { Typography } from '@material-ui/core';
import { COLOR_ERROR, COLOR_PENDING, COLOR_SUCCESSFUL, EASYPAY_PAYMENT_TYPES, EASYPAY_PAYMENT_TYPES_FORMAT } from '../../../../constants';
import styled from 'styled-components';

const COLOR_MAP = {
  pending: COLOR_PENDING,
  approved: COLOR_SUCCESSFUL,
  declined: COLOR_ERROR,
  notPaid: COLOR_PENDING,
  charged: COLOR_SUCCESSFUL,
  notCharged: COLOR_PENDING
};

const LABELS = {
  pending: 'Pending Approval',
  approved: 'Approved',
  declined: 'Declined',
  notPaid: 'Not EasyPaid',
  charged: 'Fee charged',
  notCharged: 'Fee not charged'
};

const Wrapper = styled.div`
  font-size: 12px;
`;

export const FinalizeEasyPayStatus = ({
  easyPaid,
  vehicle,
  easyPayPendingApproval,
  easyPayApproved,
  easyPayDeclined
}) => {
  const { payment_type, charge_completed } = vehicle;

  let easyPayLabel = null;
  let easyPayColor = null;

  if (easyPaid) {
    const prefix = EASYPAY_PAYMENT_TYPES_FORMAT[payment_type] || null;

    if (prefix) {
      if (easyPayPendingApproval) {
        easyPayLabel = `${prefix} ${LABELS.pending}`;
        easyPayColor = COLOR_MAP.pending;
      } else if (easyPayApproved) {
        easyPayLabel = `${prefix} ${LABELS.approved}`;
        easyPayColor = COLOR_MAP.approved;
      } else if (easyPayDeclined) {
        easyPayLabel = `${prefix} ${LABELS.declined}`;
        easyPayColor = COLOR_MAP.declined;
      }
    }
  } else {
    easyPayLabel = LABELS.notPaid;
    easyPayColor = COLOR_MAP.notPaid;
  }

  const feeLabel = charge_completed ? LABELS.charged : LABELS.notCharged;
  const feeColor = charge_completed ? COLOR_MAP.charged : COLOR_MAP.notCharged;

  return (
    <Wrapper>
      {easyPayLabel && <div style={{ color: easyPayColor, display: 'inline' }}>{easyPayLabel}</div>}
      {' - '}
      <div style={{ color: feeColor, display: 'inline' }}>{feeLabel}</div>
    </Wrapper>
  );
};
